<template>
  <loading v-if="state === 'loading'" class="mx-auto"></loading>
  <div v-else-if="state === 'empty'" class="mx-auto">
    <component :is="component"></component>
  </div>
  <div class="w-full" v-else><slot></slot></div>
</template>
<script>
import TheArtistEmptyArtwork from "./Modules/EmptyArtwork/TheArtistEmptyArtwork";
import DefaultEmptyArtwork from "./Modules/EmptyArtwork/DefaultEmptyArtwork";

export default {
  props: {
    state: {
      type: String,
      required: true,
    },
  },

  computed: {
    component () {
      let hasCustomPage = jsonFromPage('#data-custom-empty-page');
      return hasCustomPage ? TheArtistEmptyArtwork : DefaultEmptyArtwork;
    },
  }
}
</script>
